import React, { useEffect, useState } from 'react'
import UserHero from '../../userPages/partials/UserHero'
import ListGroup from '../../userPages/partials/ListGroup'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { FaForward } from 'react-icons/fa'
import UserAccount from '../../userPages/partials/UserAccount'
import FormValidation from '../../validators/Formvalidators'
import imgageValidation from "../../validators/Imagevalidators"

export default function UpdateRoomCart() {
    let [data, setData] = useState({
      name:"",
        pic:"",
        price:0,
        discount:0,
        finalPrice:0,
        stock:true,
        stockQuantity:0,
        message:"",
        active:true,
    })
    let {_id} = useParams()

    
    let [oldPic , setOldPic] = useState([])
    let [flag , setFlag] = useState(false)
   let navigate = useNavigate()
    let [show, setShow]=useState(false)
    let [errorMessage, setErrorMessage]=useState({
     
      name: "",
      price: "",
      finalPricerice: "",
      stockQuantity: "",
      pic: "",
    })
  const getInputData=(e)=>{
    let name= e.target.name;
    let value = e.target.files ? e.target?.files: e.target.value;
    console.log(name,value);
    
    if(name ==="name" || name==="pic" || name==="active" || name==="stock" || name === "message" || name==="price" || name==="discount" || name==="stockQuantity"){
     setErrorMessage((old)=>{
      return{
        ...old,
      [name]:e.target.files ? imgageValidation(e):FormValidation(e)
      }
     })
     setData((old)=>{
      return{
        ...old,
        [name]:value
      }
     })
  }
}

  async function postData(e){
    e.preventDefault()
    // ("uyiyu");
    
    let error = Object.values(errorMessage).find((x)=>x?.length > 0)
    if(error){
      setShow(true)
    }
    else{
     
      if(data){
        let newData = [data]
        // let item = Array.isArray(data) ? data.find((x)=> x.name.toLowerCase()===data.name.toLowerCase()  ):null
        let item = newData.find((x)=>x.name?.toLowerCase() === data.name.toLowerCase() && x._id !== _id)
        if(item){
          setErrorMessage((old)=>{
            return{
              ...old,
              'name':"Name is Already Exits "
            }
          })
        }
        
        else{
          let price = parseInt(data.price)
          let discount = parseInt(data.discount)
          let finalPrice = parseInt(data.price-data.price*data.discount/100)

           let formData = new FormData()
           formData.append("name", data.name)
          //  formData.append("pic", data.pic)
           formData.append("message", data.message)
           formData.append("price", price)
           formData.append("discount", discount)
           formData.append("finalPrice", finalPrice)
           formData.append("stock", data.stock)
           formData.append("stockQuantity", data.stockQuantity)
           formData.append("active", data.active)

           formData.append("oldPic" ,oldPic)
           Array.from(data.pic).forEach((p)=>{
                 formData.append("pic" , p)
           })
          let response = await fetch ("http://34.228.14.188:8000/api/roomcart/"+_id,{
            method:"PUT",
            body: formData
          })
          response = await response.json()
          
          if(response.result === "Done")
            navigate("/admin/roomcart")
          else
         alert  ("something went wrong")

        }
       
      }

      else{
        
      }
     
    }

  }

  async function getApiData() {
    let response = await fetch( "http://34.228.14.188:8000/api/roomcart/"+_id , {
           method :"GET",
           headers:{
            "content-type":"application/json",
            // "authorization":localStorage.getItem("token")
                  }
    })

    response = await response.json()
    
    if(response.result = "Done"){
      let item =   response.data
      // (response.data);
      // (item.pic);
      
      setData(item)
      setOldPic(item.pic)

    }
    else
setData([])
    
}
useEffect(()=>{
    getApiData()
} ,[_id])

  return (
   <>
   <UserHero/>

   <div className="container">
           <div className="container-fluid mt-3">
            <UserAccount/>
               <div className="row">
               <ListGroup/>
                  <div className="col-md-8">
                  <div className="admin-heading">
                  <h3>UPDATE ROOM CART <Link to="/my-account"><FaForward  className='float-end mx-2 ' /></Link> </h3>:
                           
                       </div>
                       <form  onSubmit={postData}>
                    <div className="row">
                    <div className="col-md-6 mt-3">
                        <label for="exampleFormControlInput1"  className="form-label">Name*</label>
                        <input type="text" name='name'  value={data.name} onChange={getInputData}  className="form-control" id="exampleFormControlInput1" placeholder="Room Type Name"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.name}</p>:""}
                      </div>
                      <div className="col-md-6 mt-3">
                        <label for="exampleFormControlInput1"  className="form-label">Price*</label>
                        <input type="number" name='price' value={data.price}  onChange={getInputData}  className="form-control" id="exampleFormControlInput1" placeholder="Room Price"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.price}</p>:""}
                      </div>
                    </div>

                    <div className="row">
                    <div className="col-md-6 mt-3">
                        <label for="exampleFormControlInput1"  className="form-label">Discount*</label>
                        <input type="number" name='discount' value={data.discount} onChange={getInputData}  className="form-control" id="exampleFormControlInput1" placeholder="Discount"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.discount}</p>:""}
                      </div>
                      <div className="col-md-6 mt-3">
                     <label>Stock*</label>
                  <select
                    name="stock"
                    onChange={getInputData}
                    value={data.stock}
                    className="form-select form-label"
                  >
                    <option value="true">In Stock</option>
                    <option value="false">Out of Stock</option>
                  </select>

                     </div>
                    </div>


                    <div className="mb-3 mt-3">
                  <label>Available*</label>
                  <select
                    onChange={getInputData}
                    name="active"
                    value={data.active}
                    className="form-select  form-lable"
                    style={{color:"#ad8b3a"}}
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                 


                <div className="mb-3">
                        <label for="exampleFormControlInput1" className="form-label">Room Stock Quantity *</label>
                        <input type="number" name='stockQuantity' value={data.stockQuantity}   onChange={getInputData} className="form-control" id="exampleFormControlInput1" placeholder="Room Stock Quantity"/>
                        {show && errorMessage ? <p className='text-danger'>{errorMessage.stockQuantity}</p>:""}
                        
                      </div>

                     <div className="row">
                <div className="col-md-6 mb-3">
                  <label>Pic*</label>
                  <input
                    type="file"
                    name="pic"
                    multiple
                    
                    onChange={getInputData}
                    className="form-control border-primary border-2"
                  />
                  {show && errorMessage.pic ? (
                    <p className="text-danger text-capitalize">
                      {errorMessage.pic}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-md-6 mb-3">
<label>Click on Image to Remove Old Image</label><br />
{
  oldPic?.map((item,index)=>{
    return <img src={`http://34.228.14.188:8000${item}`} key={index}  height={50} width={50}  alt="image"  
    onClick={()=>{
      oldPic.splice(index,1)
      setFlag(!flag)
    }} />
  })
}

</div>
</div>




                       <div className="mb-3">
                         <label for="exampleFormControlTextarea1"  className="form-label">Description*</label>
                         <textarea name='message' value={data.message}  onChange={getInputData}  className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder='Address....'></textarea>
                         {show && errorMessage ? <p className='text-danger'>{errorMessage.message}</p>:""}
                       
                       </div>
                       <div className="admmin-update mb-5">
                           <button className='w-100 btn-primary' type='submit'>UPDATE</button>
                       </div>
                     </form> 
                  </div>
               </div>
           </div>
          </div>
   </>
  )
}
